import React from 'react';
import { Button } from '../../ui/Button';
import { Input } from '../../ui/Input';
interface CorrespondenceAddressScreenProps {
  address: string;
  city: string;
  state: string;
  zipCode: string;
  sameAsRegistered: boolean;
  onChange: (field: string, value: any) => void;
  onNext: () => void;
  onBack: () => void;
}
export function CorrespondenceAddressScreen({
  address,
  city,
  state,
  zipCode,
  sameAsRegistered,
  onChange,
  onNext,
  onBack
}: CorrespondenceAddressScreenProps) {
  const isValid = sameAsRegistered || address.trim().length > 0 && city.trim().length > 0 && state.trim().length > 0 && zipCode.trim().length > 0;
  return <div className="flex flex-col h-full max-w-md mx-auto pt-8 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-137">
      <div className="flex-1" data-id="element-138">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-139">
          Correspondence Address
        </h2>
        <p className="text-gray-500 mb-8" data-id="element-140">
          Where should we send official mail?
        </p>

        <div className="space-y-6" data-id="element-141">
          <div className="flex items-center gap-2 mb-4" data-id="element-142">
            <input type="checkbox" id="sameAsRegistered" checked={sameAsRegistered} onChange={e => onChange('sameAsRegistered', e.target.checked)} className="h-5 w-5 rounded border-gray-300 text-[#FFD700] focus:ring-[#FFD700]" data-id="element-143" />
            <label htmlFor="sameAsRegistered" className="text-sm font-medium text-gray-700" data-id="element-144">
              Same as registered address
            </label>
          </div>

          <div className={`space-y-6 transition-opacity duration-300 ${sameAsRegistered ? 'opacity-50 pointer-events-none' : 'opacity-100'}`} data-id="element-145">
            <Input label="Street Address" placeholder="e.g. 456 Mailbox Ave" value={address} onChange={e => onChange('correspondenceAddress', e.target.value)} disabled={sameAsRegistered} data-id="element-146" />
            <div className="grid grid-cols-2 gap-4" data-id="element-147">
              <Input label="City" placeholder="e.g. New York" value={city} onChange={e => onChange('correspondenceCity', e.target.value)} disabled={sameAsRegistered} data-id="element-148" />
              <Input label="State" placeholder="e.g. NY" value={state} onChange={e => onChange('correspondenceState', e.target.value)} disabled={sameAsRegistered} data-id="element-149" />
            </div>
            <Input label="Zip Code" placeholder="e.g. 10001" value={zipCode} onChange={e => onChange('correspondenceZip', e.target.value)} disabled={sameAsRegistered} data-id="element-150" />
          </div>
        </div>
      </div>

      <div className="flex gap-4 mt-8 pb-8" data-id="element-151">
        <Button variant="secondary" onClick={onBack} className="w-1/3" data-id="element-152">
          Back
        </Button>
        <Button variant="primary" onClick={onNext} disabled={!isValid} className="w-2/3" data-id="element-153">
          Continue
        </Button>
      </div>
    </div>;
}